import { Wordmark } from '@shared/components/branding/Wordmark';

export function Logo({ className }: { className?: string }) {
  return <Wordmark className={className ? `text-foreground ${className}` : 'text-foreground'} />;
}
